import { createSlice, createSelector } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export const initialState = {
  open: false,
  locked: false,
  selectedActionGroup: null as string | null,
  // selectedTab: "DEFECTS" as string,
  showClippingPlanes: false,
  mouseTimeout: 500,
  showGooglePhotorealistic3DTileset: false,
  views: {} as Record<string, any>,
  workingMessage: null as string | null,
  alignment: null as string | null,
  openModels: [] as string[],
  animationDuration: 1,

};

const cesiumToolBarSlice = createSlice({
  name: "cesiumToolBar",
  initialState,
  reducers: {
    toggleOpen(state) {
      state.open = !state.open;
    },
    setOpenModels(state, action: PayloadAction<string[]>) {
      console.log("setOpenModels", action.payload);
      state.openModels = action.payload;
    },
    setLocked(state, action: PayloadAction<boolean>) {
      state.locked = action.payload;
    },
    setAnimationDuration(state, action: PayloadAction<number>) {
      state.animationDuration = action.payload;
    },
    setSelectedActionGroup(state, action: PayloadAction<string | null>) {
      state.selectedActionGroup = action.payload;
    },
    setMouseTimeout(state, action: PayloadAction<number>) {
      state.mouseTimeout = action.payload;
    },
    // Uncomment if you need to manage selected tabs in the future
    // setSelectedTab(state, action: PayloadAction<string>) {
    //   state.selectedTab = action.payload;
    // },
    toggleClippingPlanes(state) {
      state.showClippingPlanes = !state.showClippingPlanes;
    },

    toggleGooglePhotorealistic3DTileset(state) {
      state.showGooglePhotorealistic3DTileset = !state.showGooglePhotorealistic3DTileset;
    },
    setViews(state, action: PayloadAction<Record<string, any>>) {
      state.views = action.payload;
    },
    setWorkingMessage(state, action: PayloadAction<string | null>) {
      state.workingMessage = action.payload;
    },
    setAlignment(state, action: PayloadAction<string | null>) {
      state.alignment = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder

  },
});

export const {
  toggleOpen,
  setLocked,
  setSelectedActionGroup,
  // setSelectedTab,
  setMouseTimeout,
  toggleClippingPlanes,  
  toggleGooglePhotorealistic3DTileset,
  setViews,
  setWorkingMessage,
  setAlignment,
  setOpenModels,
  setAnimationDuration,
} = cesiumToolBarSlice.actions;

export default cesiumToolBarSlice.reducer;

export const selectCesiumToolBarOpen = (state: any) => state.cesiumToolBar.open;
export const selectOpenModels = (state: any) => state.cesiumToolBar.openModels;
export const selectCesiumToolBarLocked = (state: any) => state.cesiumToolBar.locked;
export const selectSelectedActionGroup = (state: any) => state.cesiumToolBar.selectedActionGroup;
export const selectMouseTimeout = (state: any) => state.cesiumToolBar.mouseTimeout;
export const selectAnimationDuration = (state: any) => state.cesiumToolBar.animationDuration;